import PropTypes from "prop-types";
import React from "react";
import {DragSource, DropTarget} from "react-dnd";

import Markdown from "components/shared/Markdown";
import {Task} from "v2/api/Records";

const TASK_NODE = "task-node";

const DraggableTask = (props) => {
  const {
    connectDragSource,
    connectDropTarget,
    data: {title},
    isDragging,
  } = props;
  return connectDragSource(connectDropTarget(
    <div
      className="Draggable"
      style={{opacity: Number(!isDragging)}}>
      <div className="Draggable-Content">
        <Markdown inline>{title}</Markdown>
      </div>
      <div className="Draggable-IconContainer">
        <i className="fa fa-bars" />
      </div>
    </div>
  ));
};

DraggableTask.propTypes = {
  connectDragSource: PropTypes.func.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  data: PropTypes.instanceOf(Task),
  isDragging: PropTypes.bool.isRequired,
  onMove: PropTypes.func.isRequired,
};

const dragFunc = (connect, monitor) => {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
};

const dropFunc = (connect) => {
  return {
    connectDropTarget: connect.dropTarget(),
  };
};

const taskSource = {
  beginDrag(props) {
    return {
      data: props.data,
    };
  },
  isDragging(props, monitor) {
    return props.data.id === monitor.getItem().data.id;
  },
};

const taskTarget = {
  hover(props, monitor) {
    const {id: draggedId} = monitor.getItem().data;
    const {id: afterId} = props.data;
    if (draggedId !== afterId) {
      props.onMove(draggedId, afterId);
    }
  },
};

export default DropTarget(TASK_NODE, taskTarget, dropFunc)(
    DragSource(TASK_NODE, taskSource, dragFunc)(DraggableTask)
);



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/dnd/DraggableTask.js
 **/